import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { ReleaseNotesService } from '../services/master';
import { TranslateService } from '@ngx-translate/core';
import { HasPermissionService } from 'src/app/services/common/has-permission.service';

@Component({
  standalone: false,
  selector: 'app-whats-new',
  templateUrl: './whats-new.component.html',
  styleUrls: ['./whats-new.component.scss']
})
export class WhatsNewComponent implements OnInit, OnDestroy {
  public releaseNotes: any[] = [];
  private subscriptions: Subscription[] = [];

  constructor(
    private translate: TranslateService,
    private releseNoteService: ReleaseNotesService,
    private datepipe: DatePipe,
    private router: Router,
    private permission: HasPermissionService,
  ) {}

  ngOnInit(): void {
    this.getAllReleaseNotes();
  }

  getAllReleaseNotes() {
    this.releaseNotes = [];
    this.releseNoteService.apiReleaseNotesGetReleaseNotesGet().subscribe((data: any[]) => {
      this.releaseNotes = (data || []).map(item => {
        const parsed = this.parseReleaseNotes(item.releaseNote); 
        return {
          ...item,
          releaseNote: parsed.ReleaseNotes,
          initialDate: this.parseDate(item.initialDate)
        };
      });
    });
  }

  parseDate(date: string): string {
    try {
      return this.datepipe.transform(new Date(date), 'd MMM y') || '';
    } catch {
      return '';
    }
  }

  parseReleaseNotes(jsonString: string): { ReleaseNotes: string[] } {
    try {
      const parsed = JSON.parse(jsonString);
      const arr = Array.isArray(parsed?.ReleaseNotes) ? parsed.ReleaseNotes : [];

      const normalized: string[] = arr.map((item: any) => {
        if (item && typeof item === 'object' && 'text' in item) {
          const txt = String(item.text ?? '');
          return item.isHeading ? `<strong>${this.escapeHtml(txt)}</strong>` : this.escapeHtml(txt);
        }
        if (typeof item === 'string') {
          return item;
        }
        return '';
      });

      return { ReleaseNotes: normalized };
    } catch {
      return { ReleaseNotes: [] };
    }
  }

  private escapeHtml(s: string): string {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  isHeadingHtml(s: string): boolean {
    return /^<strong>.*<\/strong>$/i.test((s || '').trim());
  }

  openEditList() {
    this.router.navigate(['/whats-new-list']);
  }

  goBackToWhatsNew(): void {
    this.router.navigate(['/whats-new']);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}